import { createSelector } from "reselect";
import { getFormValues } from "redux-form";

export function createAlertRuleFormSelectedFacilitySelector(formName) {
  return createSelector(
    getFormValues(formName),
    form => {
      if (form && form["facilityId"]) {
        return form["facilityId"];
      }
      return null;
    }
  );
}
